import React from 'react';
import { T, withAlpha } from '../designTokens';

// ---------------------------------------------------------------------------
// Batch nav bar (extracted to remove duplication)
// ---------------------------------------------------------------------------

export default function BatchNavBar({
  currentIndex,
  total,
  onNav,
}: {
  currentIndex: number;
  total: number;
  onNav: (idx: number) => void;
}) {
  return (
    <div style={{
      backgroundColor: T.gray800,
      borderBottom: `1px solid ${T.overlayFaint}`,
      padding: '10px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      flexWrap: 'wrap',
    }}>
      <button
        onClick={() => onNav(currentIndex - 1)}
        disabled={currentIndex === 0}
        style={{
          padding: '6px 16px', fontSize: '13px', fontWeight: 600,
          backgroundColor: 'transparent',
          color: currentIndex === 0 ? T.gray600 : T.cobalt300,
          border: '1px solid',
          borderColor: currentIndex === 0 ? T.gray700 : withAlpha(T.cobalt300, 0.3),
          borderRadius: '6px',
          cursor: currentIndex === 0 ? 'not-allowed' : 'pointer',
          minHeight: '34px',
        }}
      >← Previous</button>
      <span style={{
        color: T.gray400,
        fontSize: '12px',
        fontFamily: T.fontMono,
      }}>
        {currentIndex + 1} / {total} URLs scanned
      </span>
      <button
        onClick={() => onNav(currentIndex + 1)}
        disabled={currentIndex === total - 1}
        style={{
          padding: '6px 16px', fontSize: '13px', fontWeight: 600,
          backgroundColor: 'transparent',
          color: currentIndex === total - 1 ? T.gray600 : T.cobalt300,
          border: '1px solid',
          borderColor: currentIndex === total - 1 ? T.gray700 : withAlpha(T.cobalt300, 0.3),
          borderRadius: '6px',
          cursor: currentIndex === total - 1 ? 'not-allowed' : 'pointer',
          minHeight: '34px',
        }}
      >Next →</button>
    </div>
  );
}
